var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-select',{staticClass:"select-language",attrs:{"value":_vm.$i18n.locale,"size":"small"},on:{"change":_vm.onLanguageChange}},[_c('el-option',{attrs:{"value":"cn","label":_vm.$t('system.cn')}}),_c('el-option',{attrs:{"value":"en","label":_vm.$t('system.en')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }